import { useEffect, useState } from 'react'

import ConfirmationModal from 'common/components/confirmationModal'
import Drawer from 'common/components/drawer'
import { useAppSelector } from 'common/hooks/redux'
import useCreateMergeTagMutation from 'features/admin/accountSettings/api/mutations/useCreateMergeTagMutation'

import ManageMergeTagCancelButton from './ManageMergeTagCancelButton'
import ManageMergeTagForm from './ManageMergeTagForm'
import ManageMergeTagSubmitButton from './ManageMergeTagSubmitButton'

const AddMergeTagDrawer = ({ isOpen, onOpenChange }) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const [isFormDirty, setFormDirty] = useState<boolean>(false)
  const [showAddTagModal, setShowAddTagModal] = useState<boolean>(false)
  const createMergeTagMutation = useCreateMergeTagMutation()

  const handleSave = (values) => {
    createMergeTagMutation.mutate(
      { ...values, accountId },
      {
        onSuccess: () => {
          onOpenChange(false)
        },
      }
    )
  }

  //TODO: Replace with useDisablePointerEventsWhenModalVisible HH-6062
  useEffect(() => {
    // The Drawer adds pointer-events to the body, which prevents any actions from being clickable
    // when the confirmation modal is opened.
    // https://github.com/emilkowalski/vaul/issues/492
    if (!showAddTagModal) {
      return
    }

    const originalPointerEvents = document.body.style.pointerEvents

    const requestAnimation = window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = 'auto'
    })

    return () => {
      window.cancelAnimationFrame(requestAnimation)
      document.body.style.pointerEvents = originalPointerEvents
    }
  }, [showAddTagModal])

  return (
    <>
      <Drawer
        isOpen={isOpen}
        title="Configure a new ersonalisation tag"
        dismissible={!showAddTagModal}
        onOpenChange={onOpenChange}
        content={
          <ManageMergeTagForm
            onSubmit={handleSave}
            onChange={(props) => {
              const dirtyFields = Object.keys(props.dirtyFields)

              setFormDirty(dirtyFields.length > 0)
            }}
            footer={
              <>
                <ManageMergeTagCancelButton
                  onClick={() => {
                    if (isFormDirty) {
                      setShowAddTagModal(true)
                    } else {
                      onOpenChange(false)
                    }
                  }}
                  data-testid="add-merge-tag-drawer-cancel-button"
                />
                <ManageMergeTagSubmitButton
                  isLoading={createMergeTagMutation.isLoading}
                  data-testid="add-merge-tag-drawer-add-button"
                >
                  Done
                </ManageMergeTagSubmitButton>
              </>
            }
          ></ManageMergeTagForm>
        }
      />

      <ConfirmationModal
        title="Are you sure you want to leave without saving?"
        confirmationText="Any unsaved changes will be lost."
        confirmButtonText="YES, I WANT TO LEAVE"
        cancelButtonText="GO BACK"
        open={showAddTagModal}
        hasConfirmationSlider={false}
        onConfirm={() => {
          onOpenChange(false)
          setShowAddTagModal(false)
        }}
        onCancel={() => {
          setShowAddTagModal(false)
        }}
      />
    </>
  )
}

export default AddMergeTagDrawer
